module.exports = __webpack_public_path__ + "static/media/moment24.a3bc77ae.jpg";